import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import {
  DataGrid,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import { toast } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  FormControl,
  FormLabel,
  Stack,
  Typography,
  TextareaAutosize,
  Box,
  IconButton,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import format from "date-fns/format";
import {
  GetUsers,
  getBrokerBranchDetailsByBrokerBranchName,
  assignPolicyHandlerAPI
} from "../../Services/api";
import instance from "../../redux/api";
import { BANK_STATEMENT_ROW_DATA } from "../../utils/config";
import DialogBox from "../common/dialog";
import { CommonPaginationContainer, CommonSelect, CommonFilterSidebar } from "../common";
import { CommonButton } from "../common/commonButton";
import { useStyles } from "./bankTranscationContainerStyles";
import { numberFormatter } from "../../utils/generalFunctions";
import { getPaginationCount } from "../CashAllocation/utils";
import { commonToast } from "../common";
import "../common/commonPageStyles.css";


export default function AssignPolicyHandler() {
  // Selectors
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { userData } = useSelector((state) => state?.user);

  const accountsList = useSelector(
    (state) => state?.bankStatmentTransactions?.accountsList
  );

  const dispatch = useDispatch();

  // Local State
  const [selectedOption, setSelectedOption] = useState("");
  const [isOpenAddBankTxnDialog, setIsOpenAddBankTxnDialog] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [viewMode, setViewMode] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogInputValue, setDialogInputValue] = useState("");
  const [currentPaymentReferenceIndex, setCurrentPaymentReferenceIndex] =
    useState(0);

  const [selectionModel, setSelectionModel] = useState([]);

  const [open, setOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [isDeleteTxnIdValidation, setIsDeleteTxnIdValidation] = useState(null);

  const [rows, setRows] = useState([
    { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
  ]);
  const [validationStatus, setValidationStatus] = useState(
    Array(rows.length).fill(true)
  );

  const [currentUpdatedFiledsInEditMode, setCurrentUpdatedFiledsInEditMode] =
    useState({});

  // File Upload
  const [isFileUploadDialogOpen, setIsFileUploadDialogOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  //bank statement transaction search
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    bank_handler_name: {},
    policy_handler_name: {},
    Bank_Transaction_Id: "",
  });

  const [isAuditOpen, setIsAuditOpen] = useState(false);

  //Pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isAssignToTxnApiProgress, setIsAssignToTxnApiProgress] =
    useState(false);

  // Filter sidebar state
  const [filterSidebarOpen, setFilterSidebarOpen] = useState(true);

  const location = useLocation();

  // Add a new state variable at the beginning of your component to track if the submit has been initiated
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [dialogType, setDialogType] = useState("");
  const [currentCommentIndex, setCurrentCommentIndex] = useState(0);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  //styles
  const classes = useStyles();

  const Container = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
    height: "calc(100vh - 180px)",
    maxHeight: "calc(100vh - 180px)",
    overflow: "hidden",
  };

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const handleBankTransactionIdchange = (name, value) => {
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: value?.trim(),
    });
  };

  const isEmpty = (val) =>
    val === null ||
    val === undefined ||
    val === "" ||
    (typeof val === "object" && Object.keys(val).length === 0);


  const handlePolicyHandlerNameDropdown = (name, value, reason) => {
    if (reason === "clear") {
      setSearchFieldsPrams(prev => {
        const updated = { ...prev, [name]: {} };

        const allFiltersEmpty =
          Object.values(updated).every(isEmpty) &&
          fromDateValue === "" &&
          toDateValue === "";

        if (isSearchPerformed && allFiltersEmpty) {
          console.log("haha");
          handleClearSearchList();
        }

        return updated;
      });
    } else {
      setSearchFieldsPrams(prev => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const { policy_handler_name, Bank_Transaction_Id, bank_handler_name } =
      searchFieldsPrams;

    if (bank_handler_name?.user_id) {
      getSearchQueryParams = `${getSearchQueryParams}&bank_handler_name=${bank_handler_name?.user_id}`;
    }

    if (policy_handler_name?.user_id) {
      getSearchQueryParams = `${getSearchQueryParams}&policy_handler_name=${policy_handler_name?.user_id}`;
    }

    if (Bank_Transaction_Id) {
      getSearchQueryParams = `${getSearchQueryParams}&transactionId=${Bank_Transaction_Id}`;
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "dd/MM/yyyy");
      formattedToDateValue = format(toDateValue, "dd/MM/yyyy");
      getSearchQueryParams = `${getSearchQueryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchBankTransactionList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromDate")
      ) {
        let formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "dd/MM/yyyy"
        );
        let formattedToDateValue = format(
          location?.state?.toDateValue,
          "dd/MM/yyyy"
        );
        queryParams = `${queryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
      }

      let assigned = location?.state?.assigned || "";
      if (assigned) {
        queryParams = `${queryParams}&assigned=${assigned}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${assignPolicyHandlerAPI}${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
        // clear previous row selection
        handleSelectionModelChange([]);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.log("error", error);
    }
  };

  const handleClearSearchList = async () => {
    setIsClearPerformed(true);
    // clear fields
    setSearchFieldsPrams({
      bank_handler_name: {},
      policy_handler_name: {},
      Bank_Transaction_Id: "",
    });
    setFromDateValue("");
    setToDateValue("");
    setIsSearchPerformed(false);
  };

  const bankTransactionPermisson = userData?.user_permissions?.permissions_list["Bank Transactions"] ?? {};

  useEffect(() => {
    // Fetch users data from an API
    instance
      .get(GetUsers)
      .then((data) => {
        const filteredUsers = data.data.filter(
          (user) => (user.role === "CC Processor" || user.role === "Lead Role") && user.status === "Active"
        );
        setUsers([...new Set(filteredUsers)]);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const handleSubmitAssing = async () => {
    const assigningToInfo = users?.filter(
      (item) => item?.user_name === selectedUser
    );
    const assigningToId = assigningToInfo[0]?.id;

    const selectedRowsData =
      pageState?.data?.filter((row) => selectionModel.includes(row.id)) ?? [];

    try {
      setIsAssignToTxnApiProgress(true);
      const response = await instance.patch(assignPolicyHandlerAPI, {
        user_login_id: assigningToId,
        Ids: selectedRowsData?.map((item) => ({
          id: item.id,
        })),
      });
      if (response?.status === 200) {
        setIsAssignToTxnApiProgress(false);
        handleCloseDialog();
        handleSelectionModelChange([]);
        commonToast("success", "Assign successful!");
        loadData();
      } else {
        setIsAssignToTxnApiProgress(false);
        commonToast("error", "Something Went Wrong");
      }
    } catch (err) {
      console.log("err", err);
      setIsAssignToTxnApiProgress(false);
      commonToast("error", "Something Went Wrong");
    }
  };

  const handleAssignButtonClick = (params) => {
    setSelectedUser("");
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    // Load data initially and on specific dependency changes
    // if (!isSearchPerformed) {
    loadData();
    // }
  }, [
    dispatch,
    pageState?.pageSize,
    pageState?.page,
    isClearPerformed,
    // isSearchPerformed
  ]);

  // Add Mode
  useEffect(() => {
    if (selectedOption) {
      if (selectedOption === "Select Account") {
        setResponseData({});
      } else {
        const getInfo = accountsList?.filter(
          (item) => item.account_number === selectedOption
        );
        setResponseData(getInfo[0]);
      }
    }
  }, [selectedOption]);

  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  const showToast = (type, message) => {
    toast[type](message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5000,
    });
  };

  const columns = [
    {
      field: "Bank_Transaction_Id",
      headerName: "Bank Txn ID",
      headerAlign: "center",
      minWidth: "5%",
      flex: 1,
      valueGetter: (params) => params.row?.bank_txn?.Bank_Transaction_Id,
      renderCell: (params) => <>{params.row?.bank_txn?.Bank_Transaction_Id ?? ""}</>,
    },
    {
      field: "Bank_Account_Name_Entity",
      headerName: "Bank Txn Handler",
      headerAlign: "center",
      flex: 1,
      valueGetter: (params) => params.row?.bank_txn?.Assigned_User?.user_name,
      renderCell: (params) => <>{params.row?.bank_txn?.Assigned_User?.user_name ?? ""}</>,
    },
    {
      field: "policy_id",
      headerName: "Policy#",
      headerAlign: "center",
      minWidth: "25%",
      flex: 1,
      renderCell: (params) => (
        <Box
          component="span"
          onClick={() =>
            (window.location.href = `/cash-allocation?txn_id=${encodeURIComponent(params?.row?.bank_txn?.Bank_Transaction_Id)}&policy_ref=${params?.row?.id}`)
          }
          role="button"
          sx={{
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline",
            "&:hover": {
              color: "#1565c0"
            }
          }}
        >
          {params?.row?.policy_fk?.Policy_Line_Ref}
        </Box>
      ),
    },
    {
      field: "Assigned_User",
      headerName: "Policy Handler",
      headerAlign: "center",
      minWidth: "10%",
      flex: 1,
      valueGetter: (params) => params?.row?.policy_handler?.user_name,
      renderCell: (params) => (
        <>{params?.row?.policy_handler?.user_name ?? ""}</>
      ),
      filterable: true, // Enable filtering for this column
    },
    {
      field: "policy_assign_date",
      headerName: "Assign Date",
      headerClassName: "split-header",
      flex: 1,
      headerAlign: "center",
      valueGetter: (params) => params?.value,
      valueFormatter: (params) => {
        // Format the date using date-fns or any other date formatting library
        return params?.value ? format(new Date(params.value), "dd-MM-yyyy") : "-";
      },
    },
    {
      field: "receivable_amt",
      headerName: "Prem Amt",
      headerAlign: "center",
      headerClassName: "split-header",
      minWidth: "10%",
      flex: 1,
      valueGetter: (params) => params?.value,
      valueFormatter: (params) => {
        return numberFormatter(params?.value ?? 0);
      },
      cellClassName: "amount-table-cell",
    }
  ];

  const handleDialogClose = () => {
    setResponseData({});
    setIsOpenAddBankTxnDialog(false);
    setEditMode(false);
    setViewMode(false);
    setValidationStatus(Array(rows.length).fill(true));
    setUploadedFiles([]);

    // reset Rows To Initial State
    resetRowsToInitialState();
  };

  const [bankHandlerName, SetBankHandlerName] = useState([])
  const [policyHandlerName, SetPolicyHandlerName] = useState([])

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let assigned = location?.state?.assigned || "";
      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}`;

      if (assigned) {
        queryParams = `${queryParams}&assigned=${assigned}`;
      }

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      let formattedFromDateValue = "";
      let formattedToDateValue = "";

      if (location?.state?.fromDateValue && location?.state?.toDateValue) {
        formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "dd/MM/yyyy"
        );
        formattedToDateValue = format(
          location?.state?.toDateValue,
          "dd/MM/yyyy"
        );
        queryParams = `${queryParams}&fromDate=${formattedFromDateValue}&toDate=${formattedToDateValue}`;
      }

      const response = await instance.get(`${assignPolicyHandlerAPI}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
      SetBankHandlerName(response?.data?.bank_assign_users);
      SetPolicyHandlerName(response?.data?.ca_assign_users);
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  // Handler for Bank Name Dropdown
  const handleBankNameDropdownChange = (name, value, reason) => {
    console.log("name, value, reason", name, value, reason);

    if (reason === "clear") {
      setSearchFieldsPrams(prev => {
        const updated = { ...prev, [name]: {} };

        const isAllEmpty = Object.values(updated).every(
          val => val === null || val === undefined || (typeof val === "object" && Object.keys(val).length === 0) || val === ""
        ) && fromDateValue === "" && toDateValue === "";

        if (isAllEmpty) {
          console.log("clear?");
          handleClearSearchList();
        }

        return updated;
      });
    } else {
      setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
    }
  };

  // clean up data and close add or edit transaction dialog
  const cleanupTransactionData = () => {
    handleDialogClose();
    setResponseData({});
    loadData();
  };

  const errorMessages = {
    Bank_Exchange_Rate: "Exchange Rate cannot be negative.",
    // Bank_Exchange_Charges: "Exchange Charges cannot be negative.",
    Bank_Charges: "Bank Charges cannot be negative.",
  };

  const handleInputChange = async (index, colName, value) => {
    if (
      // Bank exchnage is not required
      // ["Bank_Exchange_Rate", "Bank_Exchange_Charges", "Bank_Charges"].includes(
      ["Bank_Exchange_Rate", "Bank_Charges"].includes(
        colName
      ) &&
      value < 0
    ) {
      commonToast("error", errorMessages[colName]);
      setIsSubmitting(false);
      return;
    }
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      // Auto-select logic for Txn Categorization and Broker Branch
      if (colName === "Txn_Category") {
        if (value === "Non Premium") {
          updatedRows[index][colName] = value;
          updatedRows[index]["Broker_Branch"] = "Non Premium";
          await instance
            .post(getBrokerBranchDetailsByBrokerBranchName, {
              Broker_Branch_Name: "Non Premium",
            })
            .then((response) => {
              updatedRows[index]["broker_information"] = response?.data?.id;
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        }
        else if (value !== "Non Premium" && rows[index][colName] === "Non Premium") {
          updatedRows[index][colName] = value ?? "";
          updatedRows[index]["Broker_Branch"] = "";
          updatedRows[index]["broker_information"] = "";
        }
        else {
          updatedRows[index][colName] = value ?? "";
        }
      }
      else {
        updatedRows[index][colName] = value;
      }
      setRows(updatedRows);
      validateRow(index);

      // Edit Mode
      if (editMode) {
        setCurrentUpdatedFiledsInEditMode({
          ...currentUpdatedFiledsInEditMode,
          [colName]: value,
        });
      }
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handleBrokerBranchDropdown = (index, colName, value, reason, event) => {
    const updatedRows = [...rows];
    if (updatedRows[index]) {
      // Auto-select logic for Txn Categorization and Broker Branch
      if (value === "Non Premium") {
        updatedRows[index][colName] = value;
        updatedRows[index]["Txn_Category"] = "Non Premium";
      }
      else if (value !== "Non Premium" && rows[index][colName] === "Non Premium") {
        updatedRows[index][colName] = value ?? "";
        updatedRows[index]["Txn_Category"] = "";
      }
      else {
        updatedRows[index][colName] = value ?? "";
      }
      // get broker_information (Add Mode)
      instance
        .post(getBrokerBranchDetailsByBrokerBranchName, {
          Broker_Branch_Name: value,
        })
        .then((response) => {
          updatedRows[index]["broker_information"] = response?.data?.id;
          setRows(JSON.parse(JSON.stringify(updatedRows)));
          validateRow(index);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } else {
      console.error("Row at index", index, "is undefined.");
    }
  };

  const handlePaymentReferenceOpenDialog = (
    curindex,
    currentRowPaymentRefData
  ) => {
    setDialogType("PaymentReference");
    setOpenDialog(true);
    setDialogInputValue(currentRowPaymentRefData);
    setCurrentPaymentReferenceIndex(curindex);
  };

  const handleCommentOpenDialog = (
    curindex,
    currentRowCommentData
  ) => {
    setDialogType("Comment");
    setOpenDialog(true);
    setDialogInputValue(currentRowCommentData);
    setCurrentCommentIndex(curindex);
  };

  const handleCloseDialogs = () => {
    setOpenDialog(false);
    setDialogType("");
    setIsAuditOpen(false);
  };

  const handleSavePaymentReference = () => {
    setOpenDialog(false);
    setDialogType("");
    handleInputChange(
      currentPaymentReferenceIndex,
      "Payment_Reference",
      dialogInputValue
    ); // Pass the index parameter
  };

  const handleSaveComment = () => {
    setOpenDialog(false);
    setDialogType("");
    handleInputChange(
      currentCommentIndex,
      "comment",
      dialogInputValue
    ); // Pass the index parameter
  };

  const handleDialogInputChange = (e) => {
    setDialogInputValue(e.target.value);
  };

  const handleBlur = (index, colName, value) => {
    // If the value is float
    if (!Number.isInteger(value)) {
      switch (colName) {
        case "Bank_Charges":
        // case "Bank_Exchange_Charges":
        case "Receivable_Amount":
          value = parseFloat(value).toFixed(2);
          break;
        case "Bank_Exchange_Rate":
          value = parseFloat(value).toFixed(6);
          break;
        default:
          break;
      }
    }

    const updatedRows = [...rows];
    updatedRows[index][colName] = value;
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    const status = validateRow(rows.length - 1);
    if (status) {
      setRows([
        ...rows,
        { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
      ]);
      setDialogInputValue("");
    }
  };

  const validateRow = (index) => {
    const row = rows[index];
    const fieldValidations = {};

    // Perform your validations here, for example:
    if (
      !row ||
      !row.Payment_Receive_Date ||
      !row.Payment_Receive_Date.trim() === ""
    ) {
      fieldValidations.Payment_Receive_Date = "This field is required";
    }

    if (
      !row ||
      !row.Payment_Reference ||
      !row.Payment_Reference.trim() === ""
    ) {
      fieldValidations.Payment_Reference = "This field is required";
    }

    // Update the logical OR conditions
    if (
      !row ||
      !row.Payment_Currency_Code ||
      !row.Payment_Currency_Code.trim() === ""
    ) {
      fieldValidations.Payment_Currency_Code = "This field is required";
    }

    if (
      !row ||
      !row.Receivable_Amount ||
      !row.Receivable_Amount.trim() === ""
    ) {
      fieldValidations.Receivable_Amount = "This field is required";
    }

    if (!row || !row.Txn_Category || !row.Txn_Category.trim() === "") {
      fieldValidations.Txn_Category = "This field is required";
    }

    if (!row || !row.Broker_Branch || !row.Broker_Branch.trim() === "") {
      fieldValidations.Broker_Branch = "This field is required";
    }

    // check if account number is selected
    if (!selectedOption) {
      fieldValidations.account_number = "This field is required";
    }

    if (row?.Txn_Category === "Non Premium" && (!row.comment || row.comment.trim() === "")) {
      fieldValidations.comment = "Comment is required when Txn Categorization is 'Non Premium'";
    }

    // Add more validations for other fields...
    setValidationStatus((prevStatus) => {
      const newStatus = [...prevStatus];
      newStatus[index] = fieldValidations;
      return newStatus;
    });

    return Object.keys(fieldValidations).length === 0;
  };

  const handleDeleteRow = () => {
    // Ensure there is at least one row remaining
    if (rows.length <= 1 || selectAll) {
      // Throw an error or show a message indicating that at least one row should remain
      commonToast("error", "At least One Row Should Remain!!");
      return;
    }

    const updatedRows = rows.filter((row, index) => !selectedRows[index]);
    setRows(updatedRows);

    // Clear selected rows and set Select All to false after deletion
    setSelectedRows([]);
    setSelectAll(false);
  };

  const resetRowsToInitialState = () => {
    setRows([
      { ...BANK_STATEMENT_ROW_DATA, Receiving_Bank_Account: selectedOption },
    ]);
  };

  const handleSelectionModelChange = (newSelectionModel) => {
    setSelectionModel(newSelectionModel);

    if (newSelectionModel.length === 0) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  };

  const handleFileUploadDialog = () => {
    setIsFileUploadDialogOpen(true);
  };

  const handleReloadAccountsData = () => {
    loadData();
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const { policy_handler_name, Bank_Transaction_Id, bank_handler_name } =
      searchFieldsPrams;
    console.log("policy_handler_name", policy_handler_name?.user_id)
    if (
      bank_handler_name?.user_id ||
      policy_handler_name?.user_id ||
      Bank_Transaction_Id !== "" ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }
    return disabled;
  };

  const handleSeeAllocations = () => {
    window.location.href = `/cash-allocation?txn_id=${isDeleteTxnIdValidation}`
  }

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchBankTransactionList();
    }
  };

  return (
    <div style={Container}>
      <Box sx={{ display: "flex", flexDirection: "row", height: "100%" }}>
        {/* Filter Sidebar */}
        <CommonFilterSidebar
          isOpen={filterSidebarOpen}
          filterConfigs={[
            {
              type: "custom",
              content: (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                    }}
                  >
                    Bank Handler Name
                  </Typography>
                  <CommonSelect
                    placeholder="Select Bank Handler Name"
                    value={searchFieldsPrams?.bank_handler_name ?? ""}
                    handleChange={(event, value, reason) =>
                      handleBankNameDropdownChange("bank_handler_name", value, reason, event)
                    }
                    options={bankHandlerName || []}
                    getOptionLabel={(option) => option?.username || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.user_id === value.user_id
                    }
                  />
                </Box>
              ),
            },
            {
              type: "custom",
              content: (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#000",
                      marginBottom: "12px",
                    }}
                  >
                    Policy Handler Name
                  </Typography>
                  <CommonSelect
                    placeholder="Select Policy Handler Name"
                    value={searchFieldsPrams?.policy_handler_name ?? ""}
                    handleChange={(event, value, reason) =>
                      handlePolicyHandlerNameDropdown(
                        "policy_handler_name",
                        value === "" ? null : value,
                        reason
                      )
                    }
                    options={policyHandlerName || []}
                    getOptionLabel={(option) => option?.username || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.user_id === value.user_id
                    }
                  />
                </Box>
              ),
            },
            {
              type: "textInput",
              label: "Bank Txn Number",
              placeholder: "Enter transaction ID",
              value: searchFieldsPrams?.Bank_Transaction_Id ?? "",
              onChange: (value) => handleBankTransactionIdchange("Bank_Transaction_Id", value),
              onKeyUp: handleEnter,
            },
            {
              type: "dateRange",
              label: "Date of assignment",
              startDate: fromDateValue,
              setStartDate: setFromDateValue,
              endDate: toDateValue,
              setEndDate: setToDateValue,
              maxDate: new Date(),
              onKeyUp: handleEnter,
            },
          ]}
          onApplyFilters={handleSearchBankTransactionList}
          onClearFilters={handleClearSearchList}
          isLoading={pageState?.isLoading}
          isFilterDisabled={isFilterBtnDisable()}
        />

        {/* Main Content Area */}
        <Box className="main-content-area" sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
          <Box className="page-header-container" sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px", borderBottom: "1px solid #e0e0e0" }}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Typography
                variant="h5"
                className="page-heading"
                sx={{
                  color: "#FF5A01",
                }}
              >
                Assign Policy Handler
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
              {bankTransactionPermisson?.["Allocation"] === "Y" && (
                <CommonButton
                  sx={{
                    background: isButtonDisabled ? "#CCCCCC" : "#1672DE",
                    color: "white",
                    borderRadius: "6px",
                    padding: "8px 20px",
                    width: "91px",
                    fontWeight: "500",
                    "&:hover": {
                      background: isButtonDisabled ? "#CCCCCC" : "#1565c0",
                    },
                  }}
                  text="Assign"
                  handleClick={() => handleAssignButtonClick()}
                  disabled={isButtonDisabled}
                  hoverColor="#1565c0"
                />
              )}
              <IconButton
                onClick={() => setFilterSidebarOpen(!filterSidebarOpen)}
                className="filter-toggle-button"
              >
                <FilterListIcon />
              </IconButton>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minHeight: 0,
              position: "relative",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              overflow: "visible",
              transition: "all 0.3s ease",
              border: "1px solid #e8eaf0",
              paddingBottom: "10px",
              "&:hover": {
                boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
              },
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              rowCount={pageState?.total}
              columns={columns}
              checkboxSelection
              disableRowSelectionOnClick
              keepNonExistentRowsSelected
              startIcon={<AddIcon />}
              getRowId={(row) => row?.id}
              pagination
              paginationMode="server"
              onSelectionModelChange={handleSelectionModelChange}
              selectionModel={selectionModel}
              disableSelectionOnClick
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              onPageSizeChange={(newPageSize) => {
                return setPageState((old) => {
                  setPaginationCount(
                    getPaginationCount(pageState?.total, newPageSize)
                  );
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
              }}
              rowsPerPageOptions={[10, 25, 50, 100]}
              sx={{
                border: "none",
                flex: 1,
                minHeight: 0,
                "& .MuiDataGrid-root": {
                  border: "none",
                  height: "100%",
                },
                "& .MuiDataGrid-main": {
                  height: "100%",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8f9fa",
                  borderBottom: "2px solid #e0e0e0",
                  minHeight: "52px !important",
                  maxHeight: "52px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  backgroundColor: "transparent",
                  fontWeight: "600",
                  color: "#FF5A01",
                  fontSize: "14px",
                  padding: "12px 16px",
                  borderBottom: "none",
                  overflow: "visible",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "600",
                    fontSize: "14px",
                    overflow: "visible",
                    textOverflow: "clip",
                    whiteSpace: "normal",
                    lineHeight: "1.4",
                    width: "100%",
                  },
                  "&.split-header .MuiDataGrid-columnHeaderTitle": {
                    whiteSpace: "normal",
                    lineHeight: "1.3",
                    wordBreak: "break-word",
                  },
                  "& .MuiDataGrid-sortIcon": {
                    color: "#FF5A01",
                  },
                  "& .MuiDataGrid-menuIcon": {
                    color: "#FF5A01",
                  },
                },
                "& .MuiDataGrid-columnHeader[data-field='__check__']": {
                  minWidth: "58px !important",
                  maxWidth: "58px !important",
                  padding: "0 8px",
                  "& .MuiCheckbox-root": {
                    padding: "4px",
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiDataGrid-cell[data-field='__check__']": {
                  minWidth: "58px !important",
                  maxWidth: "58px !important",
                  padding: "0 8px",
                  justifyContent: "center",
                  "& .MuiCheckbox-root": {
                    padding: "4px",
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiCheckbox-root": {
                  color: "#1672DE",
                  "&.Mui-checked": {
                    color: "#1672DE",
                  },
                  "&.MuiCheckbox-colorPrimary": {
                    color: "#1672DE",
                    "&.Mui-checked": {
                      color: "#1672DE",
                    },
                  },
                },
                "& .MuiDataGrid-row": {
                  transition: "all 0.2s ease",
                  borderBottom: "1px solid #f0f0f0",
                  "&:hover": {
                    backgroundColor: "rgba(22, 114, 222, 0.04)",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(22, 114, 222, 0.08)",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.12)",
                    },
                  },
                  "&:nth-of-type(even)": {
                    backgroundColor: "#fafafa",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.04)",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f0f0f0",
                  padding: "12px 16px",
                  fontSize: "13px",
                  color: "#333",
                  display: "flex",
                  alignItems: "center",
                  "&:focus": {
                    outline: "none",
                  },
                  "&:focus-within": {
                    outline: "none",
                  },
                },
                "& .MuiDataGrid-columnHeader[data-field='File_Name']": {
                  minWidth: toggle?.isOpen
                    ? "173.137px !important"
                    : "202px !important",
                },
                "& .MuiDataGrid-virtualScroller": {
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-track": {
                    background: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#1672DE",
                    borderRadius: "10px",
                    "&:hover": {
                      background: "#1565c0",
                    },
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "2px solid #e0e0e0",
                  backgroundColor: "#f8f9fa",
                  minHeight: "48px",
                  maxHeight: "48px",
                  paddingBottom: "8px",
                  paddingTop: "8px",
                  paddingLeft: "16px",
                  paddingRight: "16px",
                  position: "relative",
                  zIndex: 1,
                  "& .MuiTablePagination-root": {
                    color: "#666",
                    paddingRight: "16px",
                    margin: 0,
                    minHeight: "32px",
                  },
                  "& .MuiTablePagination-selectLabel": {
                    fontSize: "13px",
                    margin: 0,
                  },
                  "& .MuiTablePagination-displayedRows": {
                    fontSize: "13px",
                    margin: 0,
                  },
                  "& .MuiTablePagination-actions": {
                    marginLeft: "8px",
                    "& .MuiIconButton-root": {
                      padding: "4px",
                    },
                  },
                  "& .MuiTablePagination-select": {
                    margin: "0 8px",
                    padding: "4px 8px",
                  },
                  "& .MuiTablePagination-toolbar": {
                    minHeight: "32px",
                    padding: 0,
                  },
                },
                "& .MuiDataGrid-toolbarContainer": {
                  padding: "12px 16px",
                  backgroundColor: "#f8f9fa",
                  borderBottom: "1px solid #e0e0e0",
                  "& .MuiButton-root": {
                    color: "#1672DE",
                    fontSize: "13px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "rgba(22, 114, 222, 0.1)",
                    },
                  },
                },
                "& .MuiDataGrid-loadingOverlay": {
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                },
              }}
              components={{
                Toolbar: GridToolbarContainer,
                NoRowsOverlay: () => (
                  <Stack
                    height="100%"
                    alignItems="center"
                    justifyContent="center"
                    sx={{ color: "#999" }}
                  >
                    <Typography variant="body2" sx={{ color: "#999" }}>
                      No Transactions Found
                    </Typography>
                  </Stack>
                ),
              }}
            />
            <Stack
              sx={{
                position: "absolute",
                bottom: "16px",
                right: "20px",
                zIndex: 10,
                backgroundColor: "#f8f9fa",
                padding: "4px 8px",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
              />
            </Stack>
          </Box>
        </Box>
      </Box>


      <DialogBox
        title="Assign To"
        body={
          <FormControl sx={{ width: "100%", marginTop: "4px", boxSizing: "border-box", padding: "0" }}>
            <FormLabel
              sx={{
                marginBottom: "8px",
                fontSize: "13px",
                fontWeight: "600",
                color: "#263238",
                display: "block",
                "&.Mui-focused": {
                  color: "#1672DE",
                },
              }}
            >
              Assigning to
            </FormLabel>
            <Box sx={{ width: "100%", boxSizing: "border-box" }}>
              <CommonSelect
                name="assigning"
                value={selectedUser}
                handleChange={(event, value, reason) =>
                  setSelectedUser(value, reason)
                }
                options={users?.map((option) => option?.user_name)}
                placeholder="Select user"
                customStyles={{ width: "100%", boxSizing: "border-box" }}
              />
            </Box>
          </FormControl>
        }
        confirmText="Assign"
        isOpen={isDialogOpen}
        onCancel={handleCloseDialog}
        onConfirm={handleSubmitAssing}
        isDisableConfirm={isAssignToTxnApiProgress || !selectedUser}
        contentWidth={320}
      />
      <Dialog open={openDialog} onClose={handleCloseDialogs}>
        <DialogTitle>{dialogType === "PaymentReference" ? "Payment Reference" : dialogType === "Comment" ? "Comment" : ""}</DialogTitle>
        <DialogContent sx={{ overflow: "hidden" }}>
          <TextareaAutosize
            minRows={5}
            value={dialogInputValue}
            onChange={handleDialogInputChange}
            className="PaymentReferenceDialogue"
          />
        </DialogContent>
        <DialogActions>
          <CommonButton
            text="Cancel"
            handleClick={handleCloseDialogs}
            sx={{
              backgroundColor: "#ffff",
              color: "#000000",
              border: "1px solid #BCBDBF",
            }}
          />
          <CommonButton
            text="Save"
            handleClick={dialogType === "PaymentReference" ? handleSavePaymentReference : dialogType === "Comment" ? handleSaveComment : null}
            hoverColor="#1565c0"
          />
        </DialogActions>
      </Dialog>
    </div >
  );
}
